var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-badge"},[_c('p',{staticClass:"step-badge-title"},[_vm._v(_vm._s(_vm.stepLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }